import { ArrowRight } from "lucide-react";
import { SERVICES } from "../../data/content";
import { ChapterLabel, Container, FadeUp, MaskedLine, scrollToHash } from "./ui";

const ServiceCard = ({ service, index }) => (
  <FadeUp
    delay={(index % 3) * 0.1}
    className={`group relative overflow-hidden ${service.span}`}
    amount={0.15}
  >
    <div
      className={`relative w-full cursor-pointer overflow-hidden ${service.height}`}
      onClick={() => scrollToHash(service.target || "#demande")}
      data-testid={`service-card-${service.id}`}
    >
      <img
        src={service.image}
        alt={service.title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
      />
      <div
        className="absolute inset-0 transition-opacity duration-500"
        style={{
          background:
            "linear-gradient(to top, rgba(10,10,10,0.92) 0%, rgba(10,10,10,0.35) 55%, rgba(10,10,10,0.15) 100%)",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-champagne/0 transition-colors duration-500 group-hover:bg-champagne/[0.04]" />

      <div className="absolute inset-x-0 bottom-0 p-7 md:p-9">
        <div className="flex items-baseline gap-4">
          <span className="font-display text-[10px] font-semibold tracking-[0.2em] text-champagne">
            {service.num}
          </span>
          <h3 className="font-display text-[15px] font-semibold tracking-[0.18em] text-ivory md:text-[17px]">
            {service.title}
          </h3>
        </div>
        <p className="mt-4 max-w-[440px] font-sans text-[13px] font-light leading-[1.7] text-neutral-400">
          {service.items.join("  ·  ")}
        </p>
        {service.note && (
          <p className="mt-2 max-w-[440px] font-sans text-[12px] font-light italic leading-[1.6] text-neutral-500">
            {service.note}
          </p>
        )}
        <button
          className="mt-5 inline-flex translate-y-1 items-center gap-2 font-display text-[10px] font-semibold tracking-[0.18em] text-ivory/80 opacity-80 transition-all duration-300 group-hover:translate-y-0 group-hover:text-champagne group-hover:opacity-100"
          data-testid={`service-cta-${service.id}`}
          onClick={(e) => {
            e.stopPropagation();
            scrollToHash(service.target || "#demande");
          }}
        >
          {service.cta.toUpperCase()}
          <ArrowRight className="h-3 w-3 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  </FadeUp>
);

const Services = () => (
  <section id="services" className="bg-surface py-28 md:py-40" data-testid="services-section">
    <Container>
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
        <div>
          <ChapterLabel num="05" label="What We Handle" />
          <h2 className="mt-10 font-serif font-medium leading-[0.95] text-ivory text-[clamp(40px,5.4vw,84px)]">
            <MaskedLine delay={0.1}>DU QUOTIDIEN</MaskedLine>
            <MaskedLine delay={0.2} className="text-champagne">
              À L'EXCEPTIONNEL.
            </MaskedLine>
          </h2>
        </div>
        <FadeUp delay={0.25} className="md:pb-3">
          <p className="max-w-[280px] font-sans text-sm font-light leading-[1.7] text-neutral-400 md:text-right">
            Une même exigence de service, quel que soit le besoin.
          </p>
        </FadeUp>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-5 md:mt-20 md:grid-cols-12">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.id} service={s} index={i} />
        ))}
      </div>
    </Container>
  </section>
);

export default Services;
